import type { OnboardingEmailTemplate } from '../OnboardingEmailModal.types';

export const RENEWAL_TEMPLATE_ID = 'renewal-documents';

export const RENEWAL_DOCUMENTS_TEMPLATE: OnboardingEmailTemplate = {
  id: RENEWAL_TEMPLATE_ID,
  label: 'Renewal Document Request',
  emailSubject: 'Document request for your 409A valuation renewal',
  introduction: `Hello {{CONTACT_FIRST_NAME}},

It is time to refresh the {{COMPANY_NAME}} 409A valuation. We already have your prior-year file, so we only need what has changed since the last valuation date.

Where available, Excel versions are strongly preferred to ensure precision in our analysis.`,
  // Renewals reuse the full onboarding list so nothing is hidden, but only the
  // items that typically change between valuations start checked.
  documents: [
    {
      label: 'Financials - Year end, last fiscal year',
      name: 'Financials - Historical annual income statement and year-end balance sheet',
      description: 'for the most recent fiscal year',
    },
    {
      label: 'Financials - LTM Income Statement & Balance Sheet',
      name: 'Financials - Last twelve months income statement and balance sheet',
      description: 'as of the valuation date',
    },
    {
      label: 'Financials - NTM Projections',
      name: 'Financials - Next year financial projections',
    },
    {
      label: 'Financials - Projections, next 3 years',
      name: 'Financials - Next 3 - 5 year financial projections',
      description: 'if available',
      defaultChecked: false,
    },
    {
      label: 'Cap table - including outstanding options/warrants with their respective strike prices',
      name: 'Cap table - Cap table',
      description:
        'as of the valuation date; including outstanding options/warrants with their respective strike prices',
    },
    {
      label: 'Cap table - Amended and Restated Certificate of Organization',
      name: 'Cap table - Amended and Restated Certificate of Incorporation or Operating Agreement',
      description: 'only if amended since the last valuation',
      defaultChecked: false,
    },
    {
      label: 'Cap table - Convertible Note ledger',
      name: 'Cap table - Convertible note/SAFE ledger and convertible note/SAFE agreement(s)',
      description: 'if applicable',
    },
    {
      label: 'Latest company pitch deck',
      name: 'Other - Latest Company pitch deck',
      description: 'if updated since the last valuation',
      defaultChecked: false,
    },
    {
      label: 'List of competitors',
      name: 'Other - A list of competitors and comparable firms',
      description: 'only if the comparable set has changed',
      defaultChecked: false,
    },
    {
      label: 'Question - Secondary transactions?',
      name: 'Question - Secondary transactions',
      description: 'has the company had any secondary transactions since the last valuation?',
      kind: 'question',
    },
    {
      label: 'Question - Term sheets?',
      name: 'Question - Term sheets',
      description:
        'has the company received any term sheets or does it have any potential debt/equity transactions in process?',
      kind: 'question',
    },
  ],
};
